import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import './LoginPage.css';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const LoginPage = ({ handleLoggedIn }) => {
  const [showError, setShowError] = useState(false);

  let history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();

    const username = e.target[0].value;
    const password = e.target[1].value;
    const URL = `https://stucharge.bakersbrisk.com/api/loginapi?username=${username}&password=${password}`;
    const AuthStr = process.env.REACT_APP_AUTH_STR;

    axios
      .get(URL, {
        headers: {
          Authorization: AuthStr,
        },
      })
      .then((response) => {
        // If request is good...
        if (response.data.authenticated === true) {
          console.log(response.data);
          toast.success('Login Success, Welcome!');
          handleLoggedIn();
          localStorage.setItem('app_icon', JSON.stringify(response.data.logo));
          localStorage.setItem('user', true);
          localStorage.setItem('uname', JSON.stringify(username));
          history.push('/home');
        }
      })
      .catch((error) => {
        toast.warn('Error logging in?, check your connection');
        setShowError(true);
        e.target[0].value = '';
        e.target[1].value = '';
      });
  };

  return (
    <div className='container-login'>
      <div className='login-form'>
        <h1>
          <span>Stu</span>charge Portal
        </h1>
        <h2>Log In</h2>

        <form onSubmit={handleSubmit}>
          <div className='input-field'>
            <label htmlFor='text'>Username</label>
            <input
              type='text'
              name='username'
              placeholder='Enter username'
              id='email'
              onChange={() => setShowError(false)}
              style={{
                borderColor: showError ? 'red' : '',
              }}
              required
            />
          </div>
          <div className='input-field'>
            <label htmlFor='password'>Password</label>
            <input
              type='password'
              name='password'
              placeholder='Enter password'
              id='password'
              onChange={() => setShowError(false)}
              style={{
                borderColor: showError ? 'red' : '',
              }}
              required
            />
          </div>
          <button className='btn' type='submit'>
            Login
          </button>
          {showError ? (
            <p
              className='show-error'
              style={{ color: 'red', marginTop: '25px' }}
            >
              Username or Password don't match, please try again.
            </p>
          ) : null}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
